export class ClearApp {
    public static readonly type = '[RootState] Clear app';
}
